import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { format } from "date-fns";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { exportExcel } from "../hooks/useExportUtils";
//import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
export const ListadoFaltas = () => {
  const dt = useRef(null);
  const toast = useRef(null);
  const { selectedNomina } = useOutletContext();
  const [listadoFaltas, setListadoFaltas] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [periodosDisponibles, setPeriodosDisponibles] = useState([]);
  const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const periodoParam = queryParams.get("periodo");
    if (periodoParam) {
      setPeriodoSeleccionado(periodoParam);
    }
  }, [location.search]);

  const getData = async () => {
    try {
      const response = await axiosPrivate.get(
        "NOM/faltas?nomina=" + selectedNomina.idNomina
      );
      console.log("Faltas response:", response.data);
      const data = response.data.map((item) => {
        const fechasFormateadas = item.dias.map((fe) =>
          format(fe, "dd/MM/yyyy")
        );
        return {
          ...item,
          fechas: fechasFormateadas.join(", "),
        };
      });
      setListadoFaltas(data);
      const periodosUnicos = [
        ...new Set(data.map((item) => item.periodo)),
      ].sort((a, b) => b - a); // Orden descendente
      setPeriodosDisponibles(
        periodosUnicos.map((p) => ({ label: p.toString(), value: p }))
      );
    } catch (error) {
      console.error("Error al obtener faltas:", error);
    }
  };

  useEffect(() => {
    
    if (!selectedNomina) return;
    getData();
  }, [selectedNomina]);
  const columns = [
    { field: "numero", header: "Número", sortable: true },
    { field: "Nombre", header: "Nombre", sortable: true },
    { field: "fechas", header: "Fechas", sortable: true },
    { field: "periodo", header: "Periodo", sortable: true },
    { field: "usuario", header: "Capturo", sortable: true },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable={col.sortable}
    />
  ));

  const template2 = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];

      return (
        <>
          <span className="mx-2">Items por página:</span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </>
      );
    },
    CurrentPageReport: (options) => (
      <span className="mx-2">
        {options.first} - {options.last} de {options.totalRecords}
      </span>
    ),
  };

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  };
  const handleBack = () => {
    navigate(-1);
  };

  const faltasFiltradas = periodoSeleccionado
    ? listadoFaltas.filter((f) => f.periodo === periodoSeleccionado)
    : listadoFaltas;
  const leftToolbarTemplate = () => (
    <div className="flex gap-2 items-center flex-center">
      <label htmlFor="periodo" className="whitespace-nowrap">
        Filtrar por periodo:
      </label>
      <Dropdown
        id="periodo"
        value={periodoSeleccionado}
        options={periodosDisponibles}
        onChange={(e) => setPeriodoSeleccionado(e.value)}
        placeholder="Selecciona periodo"
        className="w-15rem"
        showClear
      />
      <Button
        label="Exportar Excel"
        icon="pi pi-file-excel"
        severity="success"
        onClick={() => exportExcel(listadoFaltas, "Faltas")}
      />
    </div>
  );

  const rightToolbarTemplate = () => (
    <span className="p-input-icon-left">
      <i className="pi pi-search" />
      <InputText
        type="search"
        placeholder="Buscar..."
        value={globalFilter}
        onChange={(e) => setGlobalFilter(e.target.value)}
        className=" ml-4"
      />
    </span>
  );
  const handleEdit = (empleado) => {
    console.log("Editar:", empleado);
    // Aquí podrías navegar a un formulario o abrir un modal
    navigate(`/faltas/${empleado.id}`); // ajusta según tu ruta
  };

  const handleDelete = (excepcion) => {
    confirmDialog({
      message: `¿Estás seguro de eliminar el registro de "${excepcion.Nombre}"?`,
      header: "Confirmar eliminación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí, eliminar",
      rejectLabel: "Cancelar",
      accept: async () => {
        try {
          await axiosPrivate.delete(`/NOM/faltas/${excepcion.id}`);
          toast.current.show({
            severity: "success",
            summary: "Eliminado",
            detail: `Registro eliminado correctamente`,
            life: 3000,
          });
          getData(); // Recargar empleados
        } catch (error) {
          console.error("Error al eliminar:", error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se pudo eliminar el empleado",
            life: 3000,
          });
        }
      },
    });
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-info p-button-sm"
          onClick={() => handleEdit(rowData)}
          tooltip="Editar"
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger p-button-sm"
          onClick={() => handleDelete(rowData)}
          tooltip="Eliminar"
        />
      </div>
    );
  };
  return (
    <div className="p-m-4">
      <Toast ref={toast} />
      <ConfirmDialog />
      <Card title="Listado de Faltas">
        <div className="mb-3 flex justify-content-between">
          <Button
            label="Regresar"
            icon="pi pi-arrow-left"
            className="p-button-secondary"
            onClick={handleBack}
          />
          <Button
            label="Agregar falta"
            icon="pi pi-list"
            className="p-button-info"
            onClick={() => navigate("/faltas")}
          />
        </div>
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        />
        <DataTable
          ref={dt}
          value={faltasFiltradas}
          //   responsiveLayout="scroll"
          paginator
          paginatorTemplate={template2}
          first={first2}
          rows={rows2}
          onPage={onCustomPage2}
          removableSort
          className="p-datatable-sm"
          stripedRows
          globalFilter={globalFilter}
          globalFilterFields={[
            "numero",
            "Nombre",
            "fechas",
            "periodo",
            "usuario",
          ]}
        >
          {dynamicColumns}
          <Column
            body={actionBodyTemplate}
            header="Acciones"
            style={{ minWidth: "10rem" }}
          />
        </DataTable>
      </Card>
    </div>
  );
};

export default ListadoFaltas;
